import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useInventory } from 'src/redux/hooks/useInventory';

import ProductPriceMappingPage from 'src/pages/ProductPage/ProductPriceMappingPage';

import EditInventoryForProductModal from 'src/atomic-components/organisms/Modals/EditInventoryForProductModal';
import InventoryHistoryDetailModal from 'src/atomic-components/organisms/Modals/InventoryDetailModal';
import Product from 'src/components/Product/Product';

import PreOrderProductPage from './PreOrderProductPage';
import ProductCompetitorTrendPage from './ProductCompetitorTrendPage';
import ProductMarketTrendPage from './ProductMarketTrendPage';
import ProductTableSelector from './ProductTableSelector';

const ProductPage: FC = () => {
  const { product } = useInventory();
  return (
    <>
      <InventoryHistoryDetailModal />
      {product && <EditInventoryForProductModal product={product} />}
      <Routes>
        <Route path='/list' element={<Product />} />
        <Route path='/table-selector' element={<ProductTableSelector />} />
        <Route path='/price-mapping' element={<ProductPriceMappingPage />} />
        <Route path='/market-price-trend' element={<ProductMarketTrendPage />} />
        <Route path='/competitor-price-trend' element={<ProductCompetitorTrendPage />} />
        <Route path='/pre-order' element={<PreOrderProductPage />} />
        <Route path='*' element={<Navigate to='./list' replace />} />
      </Routes>
    </>
  );
  // return <Product />;
};

export default ProductPage;
